<script lang="ts">
	import { DefaultButton, Icon } from "@enzianweb/shared";
	import { _ } from 'svelte-i18n';

	$: showFull = true;

	function handleClick() {
		//Link to signup page
		window.location.href = import.meta.env.VITE_SIGNUP_URL;
	}
</script>

<div class="bg-white dark:bg-dark-300 shadow-xl rounded-l-md flex gap-2 h-44">
	<button
		class="bg-secondary-200 fill-white px-1"
		on:click={() => {
			showFull = !showFull;
		}}
	>
		{#if showFull}
			<Icon name="chevron-right"></Icon>
		{:else}
			<Icon name="chevron-left"></Icon>
		{/if}
	</button>

	{#if showFull}
		<div class="flex flex-col gap-2 py-4 px-8">
			<p class="text-xl font-bold text-secondary-200 dark:text-secondary-500">
				{$_('demo.lbl_header')}
			</p>
			<p>{$_('demo.lbl_content')}</p>
			<DefaultButton text={$_('demo.bt_test_now')} onClick={handleClick}></DefaultButton>
			<p class="text-sm">{$_("demo.info_addon")}</p>
		</div>
	{/if}
</div>
